import { z } from 'zod'
import type { IconName } from '../components/Icon.tsx'

const measurementTypeBaseParameters = [
	'2ND_DOMINANT_PRECIPITATION_TYPE',
	'3RD_DOMINANT_PRECIPITATION_TYPE',
	'AGE',
	'AIR_FLOW',
	'AIR_PRESSURE',
	'AIR_PRESSURE_QFE',
	'AIR_PRESSURE_QFF',
	'AIR_PRESSURE_QNH',
	'AIR_QUALITY_INDEX',
	'AIR_TEMPERATURE',
	'ALBEDO',
	'AMBIENT_ILLUMINATION',
	'AREA',
	'BACKGROUND_LUMINANCE',
	'BATTERY_VOLTAGE',
	'BEARING',
	'BLACK_ICE_FREQUENCY',
	'CARBON_DIOXIDE',
	'CHEMICAL_AMOUNT',
	'CHEMICAL_AMOUNT_NACL',
	'CHEMICAL_CONCENTRATION',
	'CLOUD_ALTITUDE',
	'CLOUD_COVER',
	'COARSE_PARTICLE_MASS_CONCENTRATION',
	'COARSE_PARTICLE_NUMBER_CONCENTRATION',
	'COURSE',
	'CO_GAS_CONCENTRATION',
	'CURRENT',
	'DENSITY',
	'DENSITY_ALTITUDE',
	'DEW_POINT_TEMPERATURE',
	'DIFFUSE_HORIZONTAL_IRRADIATION',
	'DIRECT_NORMAL_IRRADIATION',
	'DISCOMFORT_INDEX_MODIFIED',
	'DISTANCE',
	'DOMINANT_POLLUTANT',
	'EFFECTIVE_TEMPERATURE',
	'EVAPORATION',
	'EVAPOTRANSPIRATION',
	'EVENT_TIME',
	'EXTINCTION_COEFFICIENT',
	'FINE_PARTICLE_MASS_CONCENTRATION',
	'FINE_PARTICLE_NUMBER_CONCENTRATION',
	'FOREST_FIRE_DANGER',
	'FREQUENCY',
	'FROST_POINT_TEMPERATURE',
	'FUEL_HUMIDITY',
	'FUEL_TEMPERATURE',
	'GEOPOTENTIAL_HEIGHT',
	'GLOBAL_HORIZONTAL_IRRADIATION',
	'GROUND_SPEED',
	'H2S_GAS_CONCENTRATION',
	'HAIL_ACCUMULATION',
	'HAIL_DURATION',
	'HAIL_INTENSITY',
	'HEADING',
	'HEAT_INDEX',
	'HISTORIC_DENSITY',
	'ICE_LAYER_THICKNESS',
	'INTERNAL_TEMPERATURE',
	'LATENT_HEAT_FLUX',
	'LEAF_WETNESS_DURATION',
	'LIGHTNING_STRIKES_CLOUD',
	'LIGHTNING_STRIKES_DISTANT',
	'LIGHTNING_STRIKES_NEAR',
	'LIGHTNING_STRIKES_OVERHEAD',
	'LIQUIDUS_TEMPERATURE',
	'LONG_WAVE_DIFFUSE_RADIATION',
	'LONG_WAVE_DIRECT_RADIATION',
	'LONG_WAVE_REFLECTED_RADIATION',
	'LONG_WAVE_TOTAL_RADIATION',
	'LUNG_DEPOSITED_SURFACE_AREA',
	'MIXING_LAYER_HEIGHT',
	'MIXING_RATIO',
	'MOMENTUM_FLUX',
	'MOST_DOMINANT_PRECIPITATION_TYPE',
	'NET_RADIATION',
	'NO2_GAS_CONCENTRATION',
	'NO_GAS_CONCENTRATION',
	'O3_GAS_CONCENTRATION',
	'PARTICLE_MASS_CONCENTRATION',
	'PARTICLE_MASS_CONCENTRATION_PM0_1',
	'PARTICLE_MASS_CONCENTRATION_PM1',
	'PARTICLE_MASS_CONCENTRATION_PM10',
	'PARTICLE_MASS_CONCENTRATION_PM2_5',
	'PARTICLE_NUMBER_CONCENTRATION',
	'PARTICLE_NUMBER_CONCENTRATION_PM0_1',
	'PARTICLE_NUMBER_CONCENTRATION_PM1',
	'PARTICLE_NUMBER_CONCENTRATION_PM10',
	'PARTICLE_NUMBER_CONCENTRATION_PM2_5',
	'PAR_RADIATION_GLOBAL',
	'PLANE_OF_ARRAY_IRRADIATION',
	'PITCH',
	'POWER',
	'PRECIPITATION_ACCUMULATION',
	'PRECIPITATION_INTENSITY',
	'PRESENT_WEATHER',
	'PRESENT_WEATHER_METAR',
	'PRESSURE_ALTITUDE',
	'PRESSURE_TENDENCY',
	'PRESSURE_TREND',
	'PV_PANEL_SOILING_RATIO',
	'PV_PANEL_SOILING_RATIO_2',
	'PV_PANEL_TEMPERATURE',
	'PV_PANEL_TRANSMISSION_LOSS',
	'PV_PANEL_TRANSMISSION_LOSS_2',
	'PV_REFERENCE_IRRADIATION',
	'RAIN_ACCUMULATION',
	'RAIN_DURATION',
	'RAIN_INTENSITY',
	'RELATIVE_HUMIDITY',
	'REAR_PLANE_OF_ARRAY_IRRADIATION',
	'REFLECTED_HORIZONTAL_IRRADIATION',
	'REFLECTIVITY_FACTOR',
	'RESISTANCE',
	'ROLL',
	'SEA_WATER_DENSITY',
	'SENSIBLE_HEAT_FLUX',
	'SHORT_WAVE_DIFFUSE_RADIATION',
	'SHORT_WAVE_DIRECT_RADIATION',
	'SHORT_WAVE_REFLECTED_RADIATION',
	'SHORT_WAVE_TOTAL_RADIATION',
	'SNOW_ACCUMULATION',
	'SNOW_DEPTH',
	'SNOW_DEPTH_TO_REF',
	'SNOW_DURATION',
	'SNOW_INTENSITY',
	'SNOW_LAYER_THICKNESS',
	'SO2_GAS_CONCENTRATION',
	'SOIL_HEAT_FLUX',
	'SOIL_MOISTURE',
	'SOIL_TEMPERATURE',
	'SOLAR_RADIATION',
	'SOLIDUS_TEMPERATURE',
	'STRENGTH',
	'SUB_SURFACE_TEMPERATURE',
	'SUNSHINE_DURATION',
	'SURFACE_GRIP',
	'SURFACE_STATE',
	'SURFACE_TEMPERATURE',
	'TIDE_HEIGHT',
	'TILT_ANGLE',
	'TILT_ANGLE_X',
	'TILT_ANGLE_Y',
	'TYPE',
	'ULTRAFINE_PARTICLE_MASS_CONCENTRATION',
	'ULTRAFINE_PARTICLE_NUMBER_CONCENTRATION',
	'UVA_RADIATION',
	'UVB_RADIATION',
	'UVE_RADIATION',
	'UV_DIFFUSE_RADIATION',
	'UV_DIRECT_RADIATION',
	'UV_INDEX',
	'UV_TOTAL_RADIATION',
	'VERTICAL_VISIBILITY',
	'VIBRATION_FREQUENCY',
	'VIBRATION_FREQUENCY_X',
	'VIBRATION_FREQUENCY_Y',
	'VIBRATION_FREQUENCY_Z',
	'VISIBILITY',
	'VOLTAGE',
	'VOLUMETRIC_WATER_CONTENT',
	'WATER_CONDUCTIVITY',
	'WATER_DEPTH',
	'WATER_FLOW_DIRECTION',
	'WATER_FLOW_SPEED',
	'WATER_LAYER_THICKNESS',
	'WATER_LEVEL_TO_REF',
	'WATER_PRESSURE',
	'WATER_SALINITY',
	'WATER_TEMPERATURE',
	'WATER_VAPOUR_FLUX',
	'WATER_VAPOUR_PRESSURE',
	'WAVE_COUNT',
	'WAVE_DIRECTION',
	'WAVE_HEIGHT',
	'WAVE_HEIGHT_UPPER_TENTH',
	'WAVE_HEIGHT_UPPER_THIRD',
	'WAVE_PERIOD',
	'WAVE_PERIOD_UPPER_TENTH',
	'WAVE_PERIOD_UPPER_THIRD',
	'WET_BULB_TEMPERATURE',
	'WIND_CHILL',
	'WIND_COMPONENT_U',
	'WIND_COMPONENT_V',
	'WIND_COMPONENT_Z',
	'WIND_DIRECTION',
	'WIND_GUST_DIRECTION',
	'WIND_GUST_SPEED',
	'WIND_LULL_DIRECTION',
	'WIND_POWER',
	'WIND_RUN',
	'WIND_SIGMA_THETA',
	'WIND_SPEED',
	'WIND_SQUALL_SPEED',
	'YAW',
] as const

const measurementTypeDerivedParameters = ['SUB_SURFACE_TEMPERATURE_BASE'] as const

export type MeasurementTypeParameter = (typeof measurementTypeBaseParameters)[number] | (typeof measurementTypeDerivedParameters)[number]

const baseMeasurementTypeUnits = [
	'AIR_QUALITY_INDEX',
	'AMPERES',
	'CANDELAS',
	'CANDELAS_PER_SQUARE_METRE',
	'CENTIMETRES',
	'COEFFICIENT',
	'COULOMBS',
	'COUNT',
	'CUBIC_METRES',
	'CUBIC_METRES_PER_CUBIC_METRE',
	'CUBIC_METRES_PER_HOUR',
	'DAY',
	'DECIBELS_OF_REFLECTIVITY',
	'DECIBELS_Z',
	'DEGREES',
	'DEGREES_CELSIUS',
	'DEGREES_FAHRENHEIT',
	'FOREST_FIRE_DANGER_INDEX',
	'GRAMS_PER_KILOGRAM',
	'GRAMS_PER_LITRE',
	'GRAMS_PER_SQUARE_METRE',
	'HECTOPASCALS',
	'HECTOPASCALS_PER_HOUR',
	'HERTZ',
	'HITS_PER_SQUARE_CENTIMETRE',
	'HITS_PER_SQUARE_CENTIMETRE_PER_HOUR',
	'HOUR',
	'IMPERIAL',
	'INCHES',
	'INCHES_PER_HOUR',
	'INCH_OF_MERCURY',
	'JOULES',
	'KILOAMPERES',
	'KILOGRAMS',
	'KILOGRAMS_PER_CUBIC_METRE',
	'KILOGRAMS_PER_KILOGRAM',
	'KILOGRAMS_PER_METRE',
	'KILOGRAMS_PER_SQUARE_METRE_PER_SECOND',
	'KILOMETRES',
	'KILOMETRES_PER_HOUR',
	'KILOMETRES_SQUARED',
	'KILOWATTS',
	'KILOWATT_HOURS',
	'KNOTS',
	'LUMENS',
	'LUX',
	'METRES',
	'METRES_PER_SECOND',
	'METRES_PER_SECOND_SQUARED',
	'METRIC',
	'MICROGRAMS_PER_CUBIC_METRE',
	'MILES',
	'MILES_PER_HOUR',
	'MILES_SQUARED',
	'MILLIBARS',
	'MILLIMETRES',
	'MILLIMETRES_PER_HOUR',
	'MINUTES',
	'NAUTICAL_MILES',
	'NAUTICAL_MILES_SQUARED',
	'NEWTONS',
	'NEWTONS_PER_SQUARE_METRE',
	'NO_UNIT',
	'NWS_WEATHER_CODE',
	'OCTAS',
	'OHMS',
	'ONE_PER_KILOMETRE',
	'PARTS_PER_BILLION',
	'PARTS_PER_MILLION',
	'PASCALS',
	'PERCENT',
	'PERCENTILE',
	'SECONDS',
	'SIEMENS_PER_METRE',
	'SQUARE_MICROMETRE_PER_CUBIC_CENTIMETRE',
	'SURFACE_STATE',
	'SURFACE_STATE_EN15518_3',
	'SURFACE_STATE_NTCIP',
	'SURFACE_STATE_VAISALA',
	'THOUSANDS_PER_CUBIC_CENTIMETRE',
	'UV_INDEX',
	'VOLTS',
	'WATTS',
	'WATTS_PER_SQUARE_METRE',
	'WMO_CODE_0200',
	'WMO_CODE_4678',
	'WMO_CODE_4680',
	'WMO_NIL_KIND',
] as const

const extendedMeasurementTypeUnits = [
	'USA_EPA_AIR_NOW',
	'EEA_EAQI',
	'USA_EPA_AIR_NOW_POLLUTANT_CODE',
	'EEA_EAQI_POLLUTANT_CODE',
	'EVENTS_PER_SQUARE_KILOMETRE_PER_YEAR_LONG',
	'EVENTS_PER_SQUARE_MILES_PER_YEAR_LONG',
	'EVENTS_PER_SQUARE_NAUTICAL_MILES_PER_YEAR_LONG',
	'EVENTS_PER_SQUARE_KILOMETRE_PER_YEAR_SHORT',
	'EVENTS_PER_SQUARE_MILES_PER_YEAR_SHORT',
	'EVENTS_PER_SQUARE_NAUTICAL_MILES_PER_YEAR_SHORT',
	'EVENTS_PER_SQUARE_KILOMETRE_PER_HOUR_SHORT',
	'EVENTS_PER_SQUARE_MILES_PER_HOUR_SHORT',
	'EVENTS_PER_SQUARE_NAUTICAL_MILES_PER_HOUR_SHORT',
] as const

export type MeasurementTypeUnit = (typeof baseMeasurementTypeUnits)[number] | (typeof extendedMeasurementTypeUnits)[number]

export const MeasurementTypeSchema = z.object({
	id: z.string(),
	sourceId: z.string().optional(),
	parameter: z.union([z.enum(measurementTypeBaseParameters), z.enum(measurementTypeDerivedParameters)]),
	unit: z.union([z.enum(baseMeasurementTypeUnits), z.enum(extendedMeasurementTypeUnits)]),
	statistic: z.string(),
	period: z.string(),
	height: z.number(),
	dataLevel: z.string(),
})

export type MeasurementType = z.infer<typeof MeasurementTypeSchema>

export type QualityReason = 'RANGE' | 'STEP' | 'CROSS' | 'PERSISTENCE' | 'DEVICE' | 'UNKNOWN' | 'TYPE'

export const convertMeasurementTypeToId = (type: MeasurementType | undefined) => {
	if (!type) return ''
	return `${type.parameter}:${type.unit}:${type.statistic}:${type.period}:${stringifyNumber(type.height)}:${type.dataLevel}${type.sourceId ? `:${type.sourceId}` : ''}`
}

// This is to match the backend number behavior so that we can convert back and forth.
const stringifyNumber = (num: number) => {
	let result = num.toString()
	// Check if the number is an integer or already has decimals.
	if (!result.includes('.')) {
		// Add one decimal place if it's an integer.
		result += '.0'
	} else {
		// If the number has more than one decimal, ensure no unnecessary trailing zeros.
		result = result.replace(/(\.\d*[1-9])0+$/, '$1')
	}
	return result
}

export const convertIdToMeasurementType = (id: string) => {
	const [parameter, unit, statistic, period, height, dataLevel, ...sourceId] = id.split(':')
	const measurementType = {
		id,
		parameter,
		unit,
		statistic,
		period,
		height: Number.parseFloat(height ?? '0'),
		dataLevel,
		sourceId: sourceId.join(':'),
	} as MeasurementType

	const isMeasurementType = MeasurementTypeSchema.safeParse(measurementType)
	if (isMeasurementType.success) {
		return { ...isMeasurementType.data }
	}
	return undefined
}

export const parameterToUnit: Record<string, MeasurementTypeUnit> = {
	AIR_TEMPERATURE: 'DEGREES_CELSIUS',
	CARBON_DIOXIDE: 'PARTS_PER_MILLION',
	AIR_PRESSURE: 'HECTOPASCALS',
	RELATIVE_HUMIDITY: 'PERCENT',
	WIND_SPEED: 'METRES_PER_SECOND',
	WIND_DIRECTION: 'DEGREES',
	RAIN_INTENSITY: 'MILLIMETRES_PER_HOUR',
	RAIN_ACCUMULATION: 'MILLIMETRES',
	RAIN_DURATION: 'SECONDS',
	HAIL_INTENSITY: 'HITS_PER_SQUARE_CENTIMETRE_PER_HOUR',
	HAIL_ACCUMULATION: 'HITS_PER_SQUARE_CENTIMETRE',
	HAIL_DURATION: 'SECONDS',
	SURFACE_TEMPERATURE: 'DEGREES_CELSIUS',
	FROST_POINT_TEMPERATURE: 'DEGREES_CELSIUS',
	DEW_POINT_TEMPERATURE: 'DEGREES_CELSIUS',
	SUB_SURFACE_TEMPERATURE: 'DEGREES_CELSIUS',
	SURFACE_STATE: 'SURFACE_STATE_VAISALA',
	CHEMICAL_AMOUNT_NACL: 'GRAMS_PER_SQUARE_METRE',
	NO_GAS_CONCENTRATION: 'PARTS_PER_BILLION',
	NO2_GAS_CONCENTRATION: 'PARTS_PER_BILLION',
	CO_GAS_CONCENTRATION: 'PARTS_PER_BILLION',
	O3_GAS_CONCENTRATION: 'PARTS_PER_BILLION',
	AIR_QUALITY_INDEX: 'EEA_EAQI',
	PARTICLE_MASS_CONCENTRATION_PM2_5: 'MICROGRAMS_PER_CUBIC_METRE',
	PARTICLE_MASS_CONCENTRATION_PM10: 'MICROGRAMS_PER_CUBIC_METRE',
	PARTICLE_MASS_CONCENTRATION_PM1: 'MICROGRAMS_PER_CUBIC_METRE',
	SO2_GAS_CONCENTRATION: 'PARTS_PER_BILLION',
	H2S_GAS_CONCENTRATION: 'PARTS_PER_BILLION',
	SHORT_WAVE_TOTAL_RADIATION: 'WATTS_PER_SQUARE_METRE',
	GLOBAL_HORIZONTAL_IRRADIATION: 'WATTS_PER_SQUARE_METRE',
	REFLECTED_HORIZONTAL_IRRADIATION: 'WATTS_PER_SQUARE_METRE',
	PLANE_OF_ARRAY_IRRADIATION: 'WATTS_PER_SQUARE_METRE',
	REAR_PLANE_OF_ARRAY_IRRADIATION: 'WATTS_PER_SQUARE_METRE',
	ALBEDO: 'PERCENT',
	TILT_ANGLE: 'DEGREES',
	TILT_ANGLE_X: 'DEGREES',
	TILT_ANGLE_Y: 'DEGREES',
	LONG_WAVE_DIRECT_RADIATION: 'WATTS_PER_SQUARE_METRE',
	SHORT_WAVE_DIFFUSE_RADIATION: 'WATTS_PER_SQUARE_METRE',
	LONG_WAVE_DIFFUSE_RADIATION: 'WATTS_PER_SQUARE_METRE',
	SHORT_WAVE_DIRECT_RADIATION: 'WATTS_PER_SQUARE_METRE',
	SUNSHINE_DURATION: 'SECONDS',
	PV_PANEL_TEMPERATURE: 'DEGREES_CELSIUS',
	PV_PANEL_SOILING_RATIO: 'PERCENT',
	PV_PANEL_SOILING_RATIO_2: 'PERCENT',
	PV_PANEL_TRANSMISSION_LOSS: 'PERCENT',
	PV_PANEL_TRANSMISSION_LOSS_2: 'PERCENT',
	DIFFUSE_HORIZONTAL_IRRADIATION: 'WATTS_PER_SQUARE_METRE',
	DIRECT_NORMAL_IRRADIATION: 'WATTS_PER_SQUARE_METRE',
	SNOW_ACCUMULATION: 'MILLIMETRES',
	SNOW_INTENSITY: 'MILLIMETRES_PER_HOUR',
	SNOW_DEPTH: 'METRES',
	SNOW_DEPTH_TO_REF: 'METRES',
	PV_REFERENCE_IRRADIATION: 'WATTS_PER_SQUARE_METRE',
	PRECIPITATION_ACCUMULATION: 'MILLIMETRES',
	PRECIPITATION_INTENSITY: 'MILLIMETRES_PER_HOUR',
	VISIBILITY: 'METRES',
	PRESENT_WEATHER: 'WMO_CODE_4680',
	REFLECTIVITY_FACTOR: 'DECIBELS_Z',
} satisfies Partial<Record<MeasurementTypeParameter, MeasurementTypeUnit>>

export const measurementIcons: Record<string, IconName> = {
	AIR_TEMPERATURE: 'Temperature',
	WIND_SPEED: 'Wind',
	AIR_PRESSURE: 'ArrowsDownToLine',
	RELATIVE_HUMIDITY: 'DropletPercent',
	RAIN_INTENSITY: 'Raindrops',
	RAIN_ACCUMULATION: 'Raindrops',
	RAIN_DURATION: 'Raindrops',
	DEW_POINT_TEMPERATURE: 'DropletHollow',
	FROST_POINT_TEMPERATURE: 'TemperatureSnow',
	PRECIPITATION_INTENSITY: 'CloudRain',
	PRECIPITATION_ACCUMULATION: 'CloudRain',
	SNOW_INTENSITY: 'Snowflake',
	SNOW_ACCUMULATION: 'Snowflake',
	SNOW_DEPTH: 'Snowflake',
	SNOW_DEPTH_TO_REF: 'Snowflake',
	HAIL_INTENSITY: 'VHail',
	HAIL_ACCUMULATION: 'VHail',
	HAIL_DURATION: 'VHail',
	VISIBILITY: 'Fog',
	SURFACE_TEMPERATURE: 'Road',
	SURFACE_STATE: 'Road',
	SUB_SURFACE_TEMPERATURE: 'Mound',
	SUB_SURFACE_TEMPERATURE_BASE: 'Mound',
	CHEMICAL_AMOUNT_NACL: 'SaltShaker',
	NO_GAS_CONCENTRATION: 'Smog',
	NO2_GAS_CONCENTRATION: 'Smog',
	CO_GAS_CONCENTRATION: 'Smog',
	O3_GAS_CONCENTRATION: 'Smog',
	SO2_GAS_CONCENTRATION: 'Smog',
	H2S_GAS_CONCENTRATION: 'Smog',
	PARTICLE_MASS_CONCENTRATION_PM1: 'SunDust',
	PARTICLE_MASS_CONCENTRATION_PM2_5: 'SunDust',
	PARTICLE_MASS_CONCENTRATION_PM10: 'SunDust',
} satisfies Partial<Record<MeasurementTypeParameter, IconName>>
